exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".link-count[data-v-9d733742]{color:#409eff;cursor:pointer;text-decoration:underline}.link-count[data-v-9d733742]:hover{color:#66b1ff}.expand-icon[data-v-9d733742]{transition:transform .2s;margin-right:4px}.expand-icon.expanded[data-v-9d733742]{transform:rotate(90deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-9d733742&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/UniversityManage/MenuManage/MenuManage.vue
// module id = 612
// module chunks = 0